'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getValorDecimal = getValorDecimal;
exports.maskDecimal = maskDecimal;
exports.formatarValor = formatarValor;
exports.formatarValorMonetario = formatarValorMonetario;
function getValorDecimal(valor) {
    valor = valor.replace(/\./g, '');
    valor = valor.replace(',', '.');

    return valor;
}

function maskDecimal(valor) {
    valor = valor.toString().replace(/\D/g, "");
    valor = valor.toString().replace(" ", "");
    valor = valor.toString().replace(/(\d)(\d{2})$/, "$1.$2");

    return valor;
};

function formatarValor(cents) {
    cents += '';
    cents = cents.replace(/\.|,/g, '');
    var valor = (cents / 100).toFixed(2).toString().replace(".", ",");
    valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return valor;
    // return `${(cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
}

function formatarValorMonetario(valor) {
    if (isNaN(Number(valor))) {
        var arrValueV = valor.toString().split(',');
        valor = Number(valor.replace(",", ".")).toPrecision(arrValueV[0].length + 2);
    } else {
        var arrValueP = valor.toString().split('.');
        valor = valor.toPrecision(arrValueP[0].length + 2);
    }

    valor = valor.toString().replace(".", ",");
    valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return valor;
}


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/helpers/Monetario.js
// module id = 602
// module chunks = 0